import PropTypes from "prop-types";

export default PropTypes.shape({
  jobs: PropTypes.number,
  applications: PropTypes.number,
  interviews: PropTypes.number,
  offers: PropTypes.number,
  placements: PropTypes.number,
});
